import React, { useState, useEffect } from "react";
import { ProductView } from "./ProductView";
const ProductSectionView = ({ Setlogin, LoginAccount, data }) => {
  const [loading, setLoading] = useState(false);

  console.log(data, "8888");
  return (
    <>
      <div className="">
        {loading ? (
          <div className="loader-container">
            <img
              src={require("../FormParser/images/loader.gif")}
              alt="Loading..."
            />
          </div>
        ) : (
          <div className="display-categories">
            {data && data.length >= 1 ? (
              data.map((itemObj, index) => {
                return (
                  <ProductView
                    key={itemObj.id}
                    products_for={itemObj.name || itemObj.subcategory}
                    filter_id={itemObj.sub_id}
                    product_slug={itemObj.sub_slug}
                    Setlogin={Setlogin}
                    LoginAccount={LoginAccount}
                  />
                );
              })
            ) : (
              <ProductView
                products_for="Products Section"
                Setlogin={Setlogin}
                LoginAccount={LoginAccount}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};
export { ProductSectionView };
